import { useQuery } from 'react-query'
import { axios } from 'lib'
import { toast } from 'react-toastify'
import { OrderProduct } from 'modules/orders/types'
import { ApiResponse, PaginatedParams } from 'services/api/types'

type Response = ApiResponse<
  OrderProduct & {
    canBeImported: number
    canBeImportedMessage?: string
    xPed?: string
    nItemPed?: string
  }
>

type OrderProductParams = PaginatedParams & {
  productId: string
  customerId: string
  invoiceTypeId: string
  unityId: string
  sequence: number
  proposalId: string
  mode: 'order' | 'proposal'
}

const loadOrderProduct = (data: OrderProductParams): Promise<Response> => {
  const { page = 1, limit = 10, productId, proposalId } = data
  return axios.get(`orders/proposals/${proposalId}/products/${productId}`, {
    params: {
      page,
      limit,
      ...data
    }
  })
}

export function useLoadProposalProduct(query: OrderProductParams) {
  return useQuery(
    ['orderProposalProduct', query],
    () => loadOrderProduct(query),
    {
      enabled:
        !!query.productId &&
        !!query.customerId &&
        !!query.invoiceTypeId &&
        !!query.sequence &&
        !!query.proposalId &&
        !!query.unityId,
      onError: () =>
        toast.error(`Não foi possível carregar o produto selecionado! `, {
          toastId: 'loadOrderProduct'
        })
    }
  )
}
